<!-- 
  点赞
  props: 
    refId: 传入的Id
    refType: 模块名，如 communicate
 -->
<template>
  <ul class="like-list">
    <li class="avatar" v-for="item in likeList"><img width="28" height="28" :src="item.userAvatar" :alt="item.userName"></li>
  </ul>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getReports()
  },
  props: {
    refId: {
      type: Number,
      required: true
    },
    refType: {
      type: String,
      default: 'communicate'
    }
  },
  data () {
    return {
      likeList: []
    }
  },
  methods: {
    // 获取评论和点赞
    getReports () {
      const url = '/commentApi/getLikeAndCommentInfo.html'
      const params = {
        refId: this.refId,
        refType: this.refType
      }
      api.post(url, params, (data) => {
        this.likeList = data.likeArray
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .like-list {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    z-index: 2;
    position: absolute;
    top: 43px;
    right: 46px;
    padding: 1px 6px 6px;
    width: 160px;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(192, 192, 192, 0.5);
    border-radius: 2px;
    .avatar {
      margin: 5px 10px 0px 0px;
      img {
        display: block;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// like-list.vue?5e611c33